export const categoryKeys = {
  journal: 'journal',
  cognition: 'cognition',
  hands: 'hands',
  walking: 'walking',
};

export const headerColors = {
  [categoryKeys.journal]: '#a370d6',
  [categoryKeys.cognition]: '#74d4fa',
  [categoryKeys.hands]: '#f4a6e7',
  [categoryKeys.walking]: '#6668e4',
};
